export class PipeToPiperingsModel {
    _id: string;
    id: number;
    pipeFunctionId: number;
    _pipeFunctionId: string;
    pipeFunctionName: string;
    pipeMaterialTypeId: number;
    _pipeMaterialTypeId: string;
    pipeMaterialTypeName: string;
    orientation: number;

    constructor(_id = null,
        id = null,
        pipeFunctionId = null,
        _pipeFunctionId = null,
        pipeFunctionName = null,
        pipeMaterialTypeId = null,
        _pipeMaterialTypeId = null,
        pipeMaterialTypeName = null,
        orientation = null,
    ) {
            this._id = _id;
            this.id = id;
            this.pipeFunctionId = pipeFunctionId;
            this._pipeFunctionId = _pipeFunctionId;
            this.pipeFunctionName = pipeFunctionName;
            this.pipeMaterialTypeId = pipeMaterialTypeId;
            this._pipeMaterialTypeId = _pipeMaterialTypeId;
            this.pipeMaterialTypeName = pipeMaterialTypeName;
            this.orientation = orientation;
    }
}
